<template>
  <div class="full-height">
    <article-header></article-header>
    <intro></intro>
    <blog-article :article-id="$route.params.id"></blog-article>
    <article-footer></article-footer>
  </div>
</template>

<script>
  import Intro from '../partials/IntroLarge'
  import ArticleFooter from '../partials/Footer'
  import ArticleHeader from '../partials/Header'
  import BlogArticle from './BlogArticle'

  export default {
    components: {
      ArticleHeader,
      ArticleFooter,
      Intro,
      BlogArticle
    }
  }
</script>



// WEBPACK FOOTER //
// PageArticle.vue?83653b08